import { render, staticRenderFns } from "./RrcvN_Total.vue?vue&type=template&id=65dc2bf8"
import script from "./RrcvN_Total.vue?vue&type=script&lang=js"
export * from "./RrcvN_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports